export const MAP_API_KEY = 'AIzaSyBk1Y3RjIlfRt5IyiK_SXuRwuGSQHgSsus';

export const SITE_URL = 'https://farabazaar.ir/';
export const IMAGE_URL = 'https://api.farabazaar.ir/';
export const API_URL = IMAGE_URL + 'api/v1/';
export const SITE_NAME_HOME = 'فرابازار - سامانه حمایت از حقوق مصرف کننده';
export const SITE_NAME = 'فرابازار';
export const SITE_KEYWORD = `شکایت ، ثبت شکایت، شکایت از یرند ، شکایت از محصولات، شکایت از خدمات، شکایت از خدمات پس از فروش ، شکایت از گارانتی، شکایت از
گرانفروشی، شکایت از نمایندگی، تعزیرات، شکایت تعزیرات، شکایت از اصناف ، شکایت از فروشگاه اینترنتی، شکایت از فروشگاه، سایت شکایت، شکایت
از فروشگاه زنجیره ای`;
export const SITE_DESCRIPTION = `تنها جایی که نظرات و شکایات شما ارزش دارد. نظرات و شکایات خود را در مورد محصولات و برندها ثبت و پیگیری نمایید.
تاثیر گذار باش
نظرات و شکایات با مکانیسم شفافیت و اطالع رسانی پیگیری می شوند.`;

export const GA_ID = 'UA-177780920-1';


